/** `/privacy`: Поверителност. The text is in src/app/content/privacy.tsx, each claim beside the file that makes it true. */

import { ContentPage } from '../components/ContentPage.tsx'
import { PrivacyBg, PrivacyEn } from '../content/privacy.tsx'

export function Privacy() {
  return <ContentPage titleKey="privacy.title" page="privacy" bg={<PrivacyBg />} en={<PrivacyEn />} />
}
